import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { loadUploaderTypes } from '../../../store/directusService';

import NdppUploaderModal from './NdppUploaderModal';

const NdppUploader = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();
    const [enabledContracts, setEnabledContracts] = useState([]);

    const [isNdppUploaderModalOpen, setIsNdppUploaderModalOpen] = useState(false);

    const uploaderTypes = useSelector((state) => state.entities.directusService.uploaderTypes);

    useEffect(() => {
        if (!uploaderTypes.length) dispatch(loadUploaderTypes());
    }, []);

    useEffect(() => {
        if (!uploaderTypes.length) return;
        const ndppUploaderContractIds = uploaderTypes
            .find((el) => el.name.toLowerCase() === 'ndpp uploader')
            ?.contract.map((el) => el.contract_id);

        setEnabledContracts(ndppUploaderContractIds);
    }, [uploaderTypes]);

    useEffect(() => {
        setIsNdppUploaderModalOpen(isOpen);
    }, [isOpen]);

    const onNdppUploaderModalClose = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        setIsNdppUploaderModalOpen(false);
        onClose();
    };

    const onCancel = () => {
        setIsNdppUploaderModalOpen(false);
        onClose();
    };

    return (
        <NdppUploaderModal
            contracts={enabledContracts}
            onClose={onNdppUploaderModalClose}
            isOpen={isNdppUploaderModalOpen}
            onCancel={onCancel}
        />
    );
};

export default NdppUploader;

NdppUploader.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func
};
